import { render, staticRenderFns } from "./ClaimTransaction.vue?vue&type=template&id=430babc8&"
import script from "./ClaimTransaction.vue?vue&type=script&lang=js&"
export * from "./ClaimTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ClaimTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimTransaction.vue"
export default component.exports